import { isMobileView } from '@/shared/utils/dom';

const updateMaxWidth = (
  grid: HTMLDivElement,
  mobileMaxWidth: string,
  desktopMaxWidth: string
) => {
  if (isMobileView()) {
    grid.style.maxWidth = `${mobileMaxWidth}%`;
  } else {
    grid.style.maxWidth = `${desktopMaxWidth}%`;
  }
};

const initCollectionGrid = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const myGrid = document.querySelector<HTMLDivElement>(
      '.js-collection-grid'
    );

    if (!myGrid) return;

    const mobileMaxWidth = myGrid?.dataset.mobileMaxWidth || '';
    const desktopMaxWidth = myGrid?.dataset.desktopMaxWidth || '';
    const dealWithMaxWidth = mobileMaxWidth || desktopMaxWidth;

    if (!dealWithMaxWidth) return;

    window.addEventListener('resize', () =>
      updateMaxWidth(myGrid, mobileMaxWidth, desktopMaxWidth)
    );

    updateMaxWidth(myGrid, mobileMaxWidth, desktopMaxWidth);
    myGrid.classList.remove('hidden');
  });
};

initCollectionGrid();
